<template>
  <SlidePanel :open="open" width="93%" padding-top="0px" @click:outer="$emit('close')">
    <FlexColumn v-if="applicant" :space="0" class="pa-5 pt-3">
      <FlexRow justify="space-between" class="mb-2">
        <FlexRow :space="0" align="center">
          <ApplicantListAddButton :applicant="applicant" />
          <ApplicantFavoriteAddButton :applicant="applicant" />
          <ApplicantHideButton :applicant="applicant" :hidden="hidden" />
        </FlexRow>
        <FlexRow>
          <Button icon @click="handlePrev">
            <v-icon>mdi-chevron-left</v-icon>
          </Button>
          <Button icon @click="handleNext">
            <v-icon>mdi-chevron-right</v-icon>
          </Button>
          <Button icon @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </Button>
        </FlexRow>
      </FlexRow>
  
      <Divider class="mb-4" />

      <FlexRow :space="0" flex-grow style="gap: 20px">
        <FlexRow
          :space="0"
          align="start"
          style="overflow-y: scroll; height: calc(100vh - 72px); gap: 20px"
        >
          <FlexColumn :space="0" width="320px" style="gap: 20px">
            <ApplicantSummaryView :applicant="applicant" />
            <ApplicantBasicCard :applicant="applicant" />
            <ApplicantAcademicCard :applicant="applicant" />
            <ApplicantCareersCard :applicant="applicant" />
          </FlexColumn>
          <FlexColumn width="400px" :space="0" style="gap: 20px">
            <ApplicantSkillsCard :applicant="applicant" />
            <ApplicantConditionsCard :applicant="applicant" :isSide="isSide" />
            <ApplicantCompetitionsCard :applicant="applicant" />
          </FlexColumn>
        </FlexRow>
        <FlexColumn
          no-wrap
          style="overflow-y: scroll; max-height: calc(100vh - 72px); width: calc(90vw - 760px);"
        >
          <!-- スカウト送付済み -->
          <template v-if="chatRequest">
            <FlexColumn :space="4" class="px-1">
              <FlexRow justify="center" full-width>
                <Label text="スカウトを送信済み" bold size="h6" />
              </FlexRow>
              
              <FlexColumn>
                <Label text="スカウト対象求人" bold size="subtitle-1" />
                <SelectField
                        v-model="job"
                        :items="selectJobs"
                        :outlined="false"
                        simple
                        class="mt-0"
                />
              </FlexColumn>
              
              <FlexColumn>
                <Label text="スカウト送付者" bold size="subtitle-1" />
                <FlexRow align="center">
                  <v-avatar size="40">
                    <v-img v-if="requestorProfile.imageUrl" :src="requestorProfile.imageUrl" />
                    <v-icon v-else size="40" style="color: #bbb">
                      mdi-account-circle
                    </v-icon>
                  </v-avatar>
                  <Label v-if="requestorProfile" :text="requestorProfile.lastName + requestorProfile.firstName" />

                </FlexRow>
              </FlexColumn>
              
              <FlexColumn>
                <Label text="メッセージ" bold size="subtitle-1" />
                <Label :text="chatRequest.message" text-wrap />
              </FlexColumn>
              
              <FlexColumn>
                <Label text="気になったスキル" bold size="subtitle-1" />
                <Label v-if="!chatRequest.attractiveSkills || chatRequest.attractiveSkills.length === 0" text="未選択" />
                <FlexRow wrap style="gap: 8px 0">
                  <Chip
                    v-for="skill in chatRequest.attractiveSkills"
                    size="small"
                    no-bold
                    un-clickable
                    :key="`attractive-skill-${skill}`"
                  >
                    {{ skill }}
                  </Chip>
                </FlexRow>
              </FlexColumn>
              <FlexColumn v-if="chatRequest.scoutMotivations && chatRequest.scoutMotivations.length > 0">
                <Label text="スカウトの温度感" bold size="subtitle-1" />
                <FlexColumn :space="0">
                  <Label
                    v-for="motivation in chatRequest.scoutMotivations"
                    :key="motivation"
                    :text="senses.find(item => item.value === motivation).name"
                  />
                </FlexColumn>
              </FlexColumn>
            </FlexColumn>
          </template>
          
          <!-- スカウト未送付 -->
          <template v-else>
            <FlexColumn :space="4">
              <FlexRow justify="center" full-width class="mb-6">
                <Label text="スカウトを送付する" bold size="h6" />
              </FlexRow>
              <FlexColumn :space="0">
                <Label text="スカウト対象求人" bold />
                <SelectField
                        v-model="job"
                        :items="selectJobs"
                        :outlined="false"
                        simple
                        class="mt-0"
                />
              </FlexColumn>
              <FlexColumn :space="0">
                <Label text="スカウト送付者" bold size="subtitle-1" />
                <FlexRow :space="2" align="center">
                  <SelectField
                      v-model="requestor"
                      :items="requestorItems"
                      :outlined="false"
                      simple
                      class="mt-0"
                  />
                  <v-avatar size="40">
                    <v-img v-if="requestorProfile.imageUrl" :src="requestorProfile.imageUrl" />
                    <v-icon v-else size="40" style="color: #bbb">
                      mdi-account-circle
                    </v-icon>
                  </v-avatar>
                </FlexRow>
              </FlexColumn>
              <FlexColumn :space="0">
                <Label text="テンプレート選択" bold size="subtitle-1" />
                <FlexRow
                  :space="0"
                  align="baseline"
                  class="mt-0"
                  wrap
                  style="gap: 12px 8px"
                >
                  <SelectField
                      v-model="templateId"
                      simple
                      :items="templateItems"
                      :outlined="false"
                      @change="handleApplyTemplate"
                  />
                  <FlexRow class="flex-shrink-0" style="margin-right: 1px">
                    <Button
                      outlined
                      small
                      color="primary"
                      @click="openMessageTemplateCreateDialog = true"
                    >
                      <Label text="新規" size="body-2" />
                    </Button>
                    <Button
                      outlined
                      small
                      color="primary"
                      @click="openMessageTemplateListDialog = true"
                    >
                      <Label text="編集" size="body-2" />
                    </Button>
                  </FlexRow>
                </FlexRow>
                
              </FlexColumn>
              <FlexColumn :space="0" class="mb-0">
                <Label text="スカウトメッセージ" bold size="subtitle-1" class="mb-1" />
                <TextArea
                    v-model="message"
                    :autoGrow="false"
                    :rows="18"
                    :max="1000"
                    with-limit no-label
                    class="mt-2"
                />
              </FlexColumn>
              <FlexColumn>
                <Label text="気になったスキル(任意)" bold />
                <FlexRow wrap>
                  <Label v-if="skills.length === 0" text="選択できるスキルの登録がありません"/>
                  <AttractiveSkillField v-model="attractiveSkills" :items="skills" />
                </FlexRow>
              </FlexColumn>

              <FlexRow>
                <Button
                    color="primary"
                    @click="handleSend"
                    :disabled="disabledSendButton"
                    class="mt-n1 mb-3"
                >
                  送信する
                </Button>
              </FlexRow>
            </FlexColumn>
          </template>
        </FlexColumn>
      </FlexRow>
    </FlexColumn>
    <ScoutMessageTemplateCreateDialog
        :open="openMessageTemplateCreateDialog"
        :companyId="company.id"
        @close="openMessageTemplateCreateDialog = false"
    />
    <ScoutMessageTemplateListDialog
        :open="openMessageTemplateListDialog"
        :companyId="company.id"
        @close="openMessageTemplateListDialog = false"
    />
  </SlidePanel>
</template>

<script>
import SlidePanel from "../atoms/SlidePanel";
import Button from "../atoms/Button";
import FlexColumn from "../atoms/FlexColumn";
import FlexRow from "../atoms/FlexRow";
import ApplicantSummaryView from "../molecules/ApplicantSummaryView";
import ApplicantBasicCard from "../molecules/ApplicantBasicCard";
import ApplicantAcademicCard from "../molecules/ApplicantAcademicCard";
import ApplicantCareersCard from "../molecules/ApplicantCareersCard";
import ApplicantSkillsCard from "../molecules/ApplicantSkillsCard";
import ApplicantConditionsCard from "../molecules/ApplicantConditionsCard";
import ApplicantCompetitionsCard from "../molecules/ApplicantCompetitionsCard";
import ApplicantListAddButton from "../molecules/ApplicantListAddButton";
import ApplicantFavoriteAddButton from "../molecules/ApplicantFavoriteAddButton";
import ApplicantHideButton from "../molecules/ApplicantHideButton";
import Label from "../atoms/Label";
import SelectField from "../atoms/SelectField";
import {mapGetters} from "vuex";
import TextArea from "../atoms/TextArea";
import ComponentMixin from "../ComponentMixin";
import Divider from "../atoms/Divider";
import ApiMixin from "../../ApiMixin";
import ScoutMessageTemplateCreateDialog from "./ScoutMessageTemplateCreateDialog";
import ScoutMessageTemplateListDialog from "./ScoutMessageTemplateListDialog";
import AttractiveSkillField from '../molecules/AttractiveSkillField'
import Chip from '../atoms/Chip'

export default {
  name: "ApplicantDetailPanel",
  mixins: [ComponentMixin, ApiMixin],
  components: {
    Chip,
    AttractiveSkillField,
    ScoutMessageTemplateListDialog,
    ScoutMessageTemplateCreateDialog,
    Divider,
    TextArea,
    SelectField,
    Label,
    ApplicantHideButton,
    ApplicantFavoriteAddButton,
    ApplicantListAddButton,
    ApplicantCompetitionsCard,
    ApplicantConditionsCard,
    ApplicantSkillsCard,
    ApplicantCareersCard,
    ApplicantAcademicCard, ApplicantBasicCard, ApplicantSummaryView, FlexRow, FlexColumn, Button, SlidePanel},
  props: {
    open: {
      type: Boolean
    },
    applicant: {
      type: Object
    },
    targetJob: {
      type: Object
    },
    requestorId: {
      type: String
    },
  },
  data() {
    return {
      job: undefined,
      jobs: [],
      requestor: undefined,
      templateId: undefined,
      openMessageTemplateCreateDialog: false,
      openMessageTemplateListDialog: false,
      message: "",
      attractiveSkills: [],
      scoutMotivations: [],
    }
  },
  computed: {
    ...mapGetters("client", ["company", "requestors"]),
    ...mapGetters("message", ["scoutTemplates"]),
    ...mapGetters("system", ["consts"]),
    hidden() {
      const query = this.$route.query
      const list = query.list
      return list === "hidden"
    },
    isSide() {
      return this.selectedJob.isSide
    },
    selectedJob() {
      if (!this.job || !this.jobs.length) return {}
      return this.jobs.find(job => job.id === this.job)
    },
    selectJobs() {
      return this.jobs.map(job => ({
        value: job.id,
        label: [job.name, job.isSide ? "業務委託" : "正社員"]
      }))
    },
    requestorItems() {
      return this.requestors.map(requestor => ({
        label: `${requestor.lastName} ${requestor.firstName}`,
        value: requestor.id
      }))
    },
    templateItems() {
      return this.scoutTemplates.map(template => ({
        label: template.name,
        value: template.id,
      }))
    },
    skills() {
      const skills = []
      if (this.applicant.skills.data) {
        skills.push(...this.applicant.skills.data.map(value => ({value: value, name: this.constsToText(value, this.consts.dataGoodAt)})))
      }
      if (this.applicant.skills.domain) {
        skills.push(...this.applicant.skills.domain.map(value => ({value: value, name: this.constsToText(value, this.consts.userDomain)})))
      }
      if (this.applicant.skills.tools) {
        skills.push(...this.applicant.skills.tools.map(value => ({value: value, name: this.constsToText(value, this.consts.userServiceAndTool)})))
      }
      if (this.applicant.skills.languages) {
        skills.push(...this.applicant.skills.languages.map(value => ({value: value, name: this.constsToText(value, this.consts.programmingLanguages)})))
      }
      return skills
    },
    senses() {
      return this.consts.scoutMotivation.map(item => ({
        value: item.value,
        name: item.label
      }))
    },
    disabledSendButton() {
      if (this.message == null || this.message.length === 0) {
        return true
      }
      return false
    },
    requestorProfile() {
      return this.requestors.find(item => item.id === this.requestor) || {}
    },
    chatRequest() {
      if (this.jobs.length > 0) {
        const job = this.jobs.find(item => item.id === this.job)
        if (job) {
          return job.request
        }
      }
      return this.applicant.chatRequest
    }
  },
  methods: {
    handleApplyTemplate() {
      const template = this.scoutTemplates.find(template => template.id === this.templateId)
      if (template) {
        this.message = template.detail
            .replaceAll("{{job}}", this.selectedJob.name)
            .replaceAll("{{applicant}}", `ID${this.applicant.id}`)
      }
    },
    handleSend() {
      this.sendChatRequestWithMessage(this.company.id, this.requestor, this.job, this.applicant.id, this.message, this.attractiveSkills)
    },
    handlePrev() {
      this.job = this.targetJob.id
      this.$emit("prev")
    },
    handleNext() {
      this.job = this.targetJob.id
      this.$emit("next")
    },
    async init(alreadySendRequest) {
      this.jobs = await this.loadCandidateJobs(this.applicant.id, true)
      this.job = this.job ? this.job : this.targetJob.id
      if (alreadySendRequest) {
        this.requestor = this.job !== this.targetJob ? this.selectedJob.request.requestor.id : this.applicant.chatRequest.requestor
        this.templateId = undefined
        this.scoutMotivations = this.job.id !== this.targetJob ? this.selectedJob.request.scoutMotivations : this.applicant.chatRequest.scoutMotivations
      } else {
        this.requestor = this.$cookies.get('nishika.chat-requests-requestor')
        this.templateId = this.$cookies.get('nishika.chat-requests-scout-message-template')
        this.handleApplyTemplate()
      }
    }
  },
  watch: {
    open: {
      handler(open) {
        if (open) {
          this.job = this.targetJob.id
        }
      }
    },
    job: {
      handler() {
        const alreadySendRequest = !!this.selectedJob.request
        this.init(alreadySendRequest)
      }
    },
    applicant: {
      handler(applicant) {
        if(!applicant) return;
        const alreadySendRequest = this.targetJob.id !== this.job ? !!this.selectedJob.request : !!this.applicant.chatRequest
        this.init(alreadySendRequest)
      }
    }
  }
}
</script>

<style scoped>
/* フィールド上部の不要なPaddingを削除 */
>>> .v-text-field {
  padding-top: 0 !important;
}

/* テキストエリア内、上部のマージンを下部と同一に */
>>> .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
  margin-top: 4px !important;
}
</style>
